import { Buffer } from 'buffer';
import { NewsCategory } from './news-category';
import { NewsItemDto } from './news-item-dto';
import Delta from 'quill-delta';

export class NewsItem {
  id: string;
  title: string;
  date: Date;
  categoryId: string | null;
  category: NewsCategory | null;
  excerpt: string;

  deltaContent?: Delta;
  htmlContent?: string;

  thumbnailFileName?: string;
  thumbnailUrl?: string;

  webUrl?: string;
  paywalled?: boolean;

  constructor(item: NewsItemDto) {
    this.id = item.id ?? '';
    this.title = item.title ?? '';
    this.excerpt = item.excerpt ?? '';
    this.date = item.date ?? new Date();
    this.htmlContent = item.content;
    this.deltaContent = item.contentDelta ? JSON.parse(item.contentDelta) : undefined;
    this.thumbnailFileName = item.thumbnailFileName;
    this.thumbnailUrl = item.thumbnailUrl;

    this.webUrl = item.webUrl;
    this.categoryId = item.categoryId ?? null;
    this.category = item.category ?? null;
  }
}
